// -----------------------------------------------------------------------------
// MOCK DATA — Юзлем Идриз · Психолог
// Статично съдържание за лендинг страницата.
// Резервациите се обработват от бекенда: /api/bookings
// -----------------------------------------------------------------------------

export const images = {
  hero: "https://images.pexels.com/photos/34077028/pexels-photo-34077028.jpeg?auto=compress&cs=tinysrgb&w=1920",
  portrait: "/images/ozlem-portrait-2026.webp",
  studio1: "/images/ozlem-studio-1.jpg",
  studio2: "/images/ozlem-studio-2.jpg",
  session1: "https://images.unsplash.com/photo-1714976694810-85add1a29c96?w=900&q=80",
  session2: "https://images.unsplash.com/photo-1758273241086-f3585ef8c2f8?w=900&q=80",
  pampas: "https://images.unsplash.com/photo-1570451488142-71d08e1511e3?w=900&q=80",
  texture: "https://images.pexels.com/photos/12998745/pexels-photo-12998745.jpeg",
  tea: "https://images.unsplash.com/photo-1596507275836-bc5fe58bfd08?w=900&q=80",
  teapot: "https://images.unsplash.com/photo-1593532320143-0fe08058387a?w=900&q=80",
};

export const navLinks = [
  { label: "За мен", target: "about" },
  { label: "Услуги", target: "services" },
  { label: "Подход", target: "approach" },
  { label: "Отзиви", target: "testimonials" },
  { label: "Контакт", target: "contact" },
];

export const marqueeItems = [
  "Индивидуална терапия",
  "Групова терапия",
  "Онлайн сесии",
  "Тревожност и стрес",
  "Житейски кризи",
  "Личностно развитие",
];

export const about = {
  intro:
    "Аз съм Юзлем Идриз — психолог и психотерапевт. Вярвам, че всяка промяна започва с един истински разговор — в пространство, където можете да бъдете себе си, без осъждане.",
  heading: "За мен",
  paragraphs: [
    "Казвам се Юзлем Идриз и съм психолог и психотерапевт.",
    "Преди да се посветя на психотерапията, повече от 15 години работех в корпоративния свят. Този опит ме срещна отблизо с високото темпо, голямата отговорност и моментите, в които човек неусетно започва да се отдалечава от себе си.",
    "Днес работя с хора, които преминават през раздяла, загуба, тревожност или житейска криза — моменти, в които старите начини да се справяме вече не работят.",
    "Вярвам, че зад всеки симптом стои история, която заслужава да бъде чута, а не осъдена. В терапията създавам пространство, в което можете да бъдете себе си — без необходимост да изглеждате силни, спокойни или „добре“.",
    "Работя с неорайхианска психотелесна психотерапия — подход, който разглежда психиката и тялото като едно цяло. Защото това, което не успяваме да изречем, често остава записано в тялото.",
    "Не вярвам в готовите съвети. Вярвам в срещата, в която човек постепенно открива собствените си отговори.",
  ],
  credentials: [
    "Магистър по психология — ВТУ „Св. св. Кирил и Методий“",
    "Дипломиран неорайхиански психотелесен психотерапевт",
    "Специалист по хуманитарна помощ в критични ситуации (Humanitarian Emergency ASSYSY Response Training — HEART)",
    "Редовен член на БНПД",
  ],
};

export const services = [
  {
    id: "individual",
    index: "01",
    title: "Индивидуална терапия",
    annotation: "(среща със себе си)",
    description:
      "Пространство само за вас. Място, в което можете да бъдете себе си и заедно да работим върху тревожността, емоционалното прегаряне, ниската самооценка, житейските кризи и предизвикателствата във взаимоотношенията — с уважение към вашето темпо.",
    duration: "50 мин",
    price: "50 €",
    image: "/images/ozlem-studio-2.jpg",
  },
  {
    id: "group",
    index: "02",
    title: "Групова терапия",
    annotation: "(заедно с други)",
    description:
      "Пространство, в което не сте сами. Груповата терапия дава възможност да бъдете чути, да се разпознаете в историите на другите и да изградите нов начин на свързване — в атмосфера на доверие, уважение и подкрепа.",
    duration: "",
    price: "",
    image: "https://images.unsplash.com/photo-1570451488142-71d08e1511e3?w=900&q=80",
  },
  {
    id: "online",
    index: "03",
    title: "Онлайн консултация",
    annotation: "(отвсякъде)",
    description:
      "Същото качество на терапевтичната връзка — от вашия дом, където и да сте. Подходящо за живеещи в чужбина или с натоварен график.",
    duration: "50 мин",
    price: "50 €",
    image: "https://images.unsplash.com/photo-1596507275836-bc5fe58bfd08?w=900&q=80",
  },
];

export const approach = {
  statement:
    "Терапията не е търсене на съвършенство. Тя е среща със себе си — с повече разбиране, свобода и вътрешна опора.",
  principles: [
    {
      index: "01",
      title: "Безусловно приемане",
      text: "Тук няма правилни и грешни чувства. Всичко, което носите, има място в този разговор.",
    },
    {
      index: "02",
      title: "Доверие и поверителност",
      text: "Всичко споделено остава между нас. Терапевтичната връзка се гради върху абсолютна дискретност.",
    },
    {
      index: "03",
      title: "Вашето темпо",
      text: "Не бързаме. Промяната се случва тогава, когато сте готови — моята задача е да бъда до вас по пътя.",
    },
  ],
};

export const testimonials = [
  {
    id: 1,
    quote:
      "Изключително съм доволна от работата с Юзлем. Тя е невероятен професионалист — търпелива, внимателна и съпричастна. От първата ни среща се почувствах спокойна и разбрана. Благодарение на нейната подкрепа и насоки се чувствам по-уверена и щастлива. Препоръчвам я на всеки, който търси истинска промяна и подкрепа.",
    author: "Васка С.",
    context: "индивидуална терапия",
  },
  {
    id: 2,
    quote:
      "Юзлем ме изслуша внимателно и лесно създаде усещане за безопасност и разбиране. Чувствах се по-леко, след като споделих проблемите си, и получих някои полезни насоки за това как да работя върху себе си. Сега се чувствам по-оптимистичен и мотивиран да продължа с терапията. Благодаря.",
    author: "Александър П.",
    context: "индивидуална терапия",
  },
  {
    id: 3,
    quote:
      "Срещата беше интересна, тематична и полезна. Проведохме практика, в която бяха поставени въпроси за размисъл и равносметка. Терапевтът е добре подготвен, има индивидуален подход и искрено желание да ни помага в пътя на себепознаването и личностното израстване. Ще продължа да посещавам! Благодаря!",
    author: "Даниела П.",
    context: "групова терапия",
  },
  {
    id: 4,
    quote:
      "Присъствах на ритуал за равносметка на изминалата година. Запознах се с различни и интересни хора. Изключително съм доволна от срещата с г-жа Идриз. Внимателна, задава точните въпроси, обяснява разбираемо. Много приятно, ползотворно и изпълнено с емоции време! Препоръчвам!",
    author: "Катерина Ж.",
    context: "групова терапия",
  },
  {
    id: 5,
    quote:
      "Живея в Норвегия и мислех, че онлайн терапията ще е компромис. Оказа се едно от най-ценните неща, които съм правила за себе си.",
    author: "В. П.",
    context: "онлайн консултации",
  },
];

export const faq = [
  {
    q: "Как протича първата среща?",
    a: "Първата сесия е опознавателна — разговаряме за това, което ви води при мен, и заедно очертаваме посоката на работа. Няма нужда от подготовка — елате такива, каквито сте.",
  },
  {
    q: "Колко дълго продължава терапията?",
    a: "Няма универсален отговор. Някои теми се разгръщат за няколко срещи, други изискват по-дълъг процес. Обикновено след 3–4 сесии имаме яснота за реалистичен хоризонт.",
  },
  {
    q: "Поверителни ли са разговорите ни?",
    a: "Абсолютно. Всичко споделено в кабинета остава там — това е основен етичен принцип в моята работа, регламентиран и от професионалния кодекс.",
  },
  {
    q: "Работите ли онлайн?",
    a: "Да — провеждам сесии през защитена видео връзка. Онлайн форматът е пълноценен и подходящ за хора извън Пловдив или в чужбина.",
  },
  {
    q: "Как мога да отменя или преместя час?",
    a: "Моля, уведомете ме поне 24 часа предварително — така часът може да бъде предложен на друг човек, който има нужда от него.",
  },
];

export const contact = {
  address: "ул. „Патриарх Евтимий“ 15, Пловдив",
  phone: "+359 898 87 12 65",
  email: "ozlem.idriz@gmail.com",
  hours: "понеделник – петък · 09:00 – 19:00",
  city: "Пловдив, България",
};

export const timeSlots = [
  "09:00", "10:00", "11:00", "12:00",
  "14:00", "15:00", "16:00", "17:00", "18:00",
];

// Резервациите вече се обработват от бекенда: /api/bookings
